import "./BookYourClean.module.css";
import PlatformHeader from "@/reusable_sections/Header";
import InquiryPortal from "./sections/InquiryPortal";
import FindNearestSalon from "./sections/FindNearestSalon";
import FrameworkInquiries from "./sections/FrameworkInquiries";
import Footer from "@/reusable_sections/Footer";
export default function BookYourCleanPage() {
  return <div>
      <PlatformHeader />
      <InquiryPortal />
      <FindNearestSalon />
      <FrameworkInquiries />
      <Footer />
    </div>;
}